import { create } from 'zustand';
import type { TripStopLocation } from 'contracts/transport-routes';

type FormValues = Partial<{
  origin_uf: string;
  origin_ibge: string;
  destination_uf: string;
  destination_ibge: string;
}>

type Coordinates = Partial<{
  origin_lat: string;
  origin_lng: string;
  destination_lat: string;
  destination_lng: string;
}>

type State = {
  forwardTripFormValues: FormValues;
  forwardTripCoordinates: Coordinates;
  forwardTripStopLocations: TripStopLocation[];
}

type Actions = {
  updateForwardTripFormValues: (formValues: FormValues) => void;
  updateForwardTripCoordinates: (coordinates: Coordinates) => void;
  updateForwardTripStopLocations: (stopLocations: TripStopLocation[]) => void;
  clearForwardTripState: () => void;
}

const getInitialState = (): State => ({
  forwardTripFormValues: {},
  forwardTripCoordinates: {},
  forwardTripStopLocations: [],
});

export const useForwardTripState = create<State & Actions>(
  (set, get) => ({
    ...getInitialState(),
    updateForwardTripFormValues: (updatedFormValues) => set({
      forwardTripFormValues: {
        ...get().forwardTripFormValues,
        ...updatedFormValues,
      },
    }),
    updateForwardTripCoordinates: (coordinates) => set({
      forwardTripCoordinates: {
        ...get().forwardTripCoordinates,
        ...coordinates,
      },
    }),
    updateForwardTripStopLocations: (stopLocations) => set({
      forwardTripStopLocations: stopLocations,
    }),
    clearForwardTripState: () => set(getInitialState()),
  }),
);